import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'exchange.list.pagination', {});
export const getFilters = (state) => get(state, 'exchange.list.filters', {});

export const getExchangeIds = (state) => get(state, 'exchange.list.result.exchange', []);
export const getExchange = (state) => get(state, 'exchange.list.entities.exchange', {});

export const getIsLoading = (state) => get(state, 'exchange.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'exchange.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'exchange.form.isFetching', false);
export const getIsSaving = (state) => get(state, 'exchange.form.isSaving', false);
export const getEditing = (state) => get(state, 'exchange.form.editing', {});

export const getVisibleExchange = createSelector([getExchangeIds, getExchange], (ids, exchanges) =>
  ids.map((id) => exchanges[id]).filter((account) => !account.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/selectors/exchange_selectors.js